module.exports = __webpack_public_path__ + "static/headshot-samuel-keeley-2x.ad4540cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-samuel-keeley-2x.jpg
// module id = 531
// module chunks = 152909308826437